import { render, staticRenderFns } from "./TextArea1.vue?vue&type=template&id=491cae37&scoped=true"
import script from "./TextArea1.vue?vue&type=script&lang=js"
export * from "./TextArea1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491cae37",
  null
  
)

export default component.exports